import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import Toast from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import i18n from './i18n'

import App from './App.vue'
import router from './router'
import MaintenanceView from './views/maintenance/MaintenanceView.vue'

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.data?.value === 'Session expired') {
      localStorage.removeItem('token')
    }

    return Promise.reject(error)
  }
)

// Con VITE_MAINTENANCE_MODE=true solo se monta el aviso de mantenimiento: sin
// router ni stores, ninguna ruta es accesible y no se llama a la API. Vite fija
// el valor al compilar, así que cambiarlo exige volver a hacer el build.
if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
  createApp(MaintenanceView).use(i18n).mount('#app')
} else {
  mountApp()
}

function mountApp() {
  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  app.use(Toast, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    containerId: "toast-container",
    transition: "bounce",
    limit: 3,
    newestOnTop: true,
    rtl: false,
    theme: "light",
    pauseOnFocusLoss: true,
    closeButton: true,
    enableMultiContainer: false,
    containerClassName: "toast-container",
    containerStyle: {
      position: "fixed",
      zIndex: 20
    }
  })
  app.use(i18n)

  app.mount('#app')
}
